export const mappedBooleanDisplayValue = (value: boolean) => {
  return value ? 'On' : 'Off';
};
